import "./videoView.scss";

import { PlayableItem } from "~pages/rootPage";
import { convertDuration } from "~tools/convert";
import { checkImage } from "~tools/tool";
import { DOMHelper, View } from "~ui-lib";

export class VideoView extends View {
  constructor(item: PlayableItem, isDetail: boolean, isPlaying = false) {
    super(DOMHelper.createDivWithParent(null, item.id, "ItemVideoVignette"));
    const box = DOMHelper.createDivWithParent(this.rootElement, null, "ItemVideoViewBoxZoom");
    const elementImg = DOMHelper.createDivImg(box, null, "elementImg");
    if (item.artworks) {
      if (!isPlaying) DOMHelper.createDivWithParent(elementImg, null, "videoMask");
      const videoInfoBox = DOMHelper.createDivWithParent(elementImg, null, "videoInfoBox");
      DOMHelper.createDivImg(videoInfoBox, null, "playIconItem", require("~images/pictos_options/play.png"));

      let title = "";
      let episodeName = "";
      let season = "";
      let episode = "";
      if (item.extras?.event) {
        // if video is link to a event
        title = item.extras.event.title || "";
        episodeName = item.title || "";
        season = item.extras.season || "";
        episode = item.extras.episode || "";
      } else if (item.extras?.program) {
        // if video is link to a program
        title = item.extras.program.title || "";
        episodeName = item.title || "";
        season = item.extras.season || "";
        episode = item.extras.episode || "";
      } else {
        title = item.title || "";
        if (item.extras) {
          season = item.extras.season || "";
          episode = item.extras.episode || "";
        }
      }
      if (isDetail) season = "";
      let videoTitle: HTMLElement;
      if (episodeName) {
        videoTitle = DOMHelper.createDivWithParent(videoInfoBox, null, "videoTitle", episodeName);
      }
      if (season || episode)
        DOMHelper.createDivWithParent(
          videoInfoBox,
          null,
          "videoSeason",
          season
            ? episode
              ? `saison ${season}, épisode ${episode}`
              : `saison ${season}`
            : episode
            ? `épisode ${episode}`
            : ""
        );

      let videoTitleProgram: HTMLElement;
      if (title) {
        videoTitleProgram = DOMHelper.createDivWithParent(videoInfoBox, null, "videoTitleProgram", title);
      }

      if (item.metadata) {
        if (item.metadata.duration)
          DOMHelper.createDivWithParent(videoInfoBox, null, "videoDuration", convertDuration(item.metadata.duration));
      }

      const imgUrl = item.getLandscapeTileImgUrl();
      if (imgUrl !== "") {
        checkImage(
          imgUrl,
          () => {
            elementImg.style.background = `url("${imgUrl}") no-repeat`;
            elementImg.style.backgroundSize = "100%";
            if (videoTitle && videoTitleProgram) {
              videoTitleProgram.classList.add("hide");
            } else if (videoTitleProgram) {
              videoTitleProgram.classList.add("bold");
            }
          },
          () => {}
        );
      }
    }
    if (isPlaying) {
      const mask = DOMHelper.createDivWithParent(elementImg, null, "elementImgMask");
      DOMHelper.createSpanWithParent(mask, null, "maskText", "en cours de lecture");
    }
  }

  onFocused = () => {};
}
